<template>
  
  <!-- Module -->
  <div class="module">
    <div class="module__media bg-dark-pink"></div>
    <div class="module__header">
      <h2>Search by programme name or keyword</h2>
    </div>  
    <div class="module__main">

      <!-- Search Form -->
      <search-form>

        <!-- Search Input -->
        <fieldset>
          <div class="form-control form-control--search">
            <search-input></search-input>
            <button type="submit">
              <span class="sr-only">Search</span>
              <i class="icon-search" aria-hidden="true"></i>
            </button>
          </div>
        </fieldset>

        <!-- Collapse Toggle -->
        <button type="button" class="button button--small button--block button--toggle toggle toggle--m" aria-expanded="false" aria-controls="search-filters" data-toggle="true">
          Filter programmes
          <span v-if="isFiltering" class="badge bg-white">{{ filtersCount }}</span>
        </button>

        <!-- Collapse -->
        <div id="search-filters" class="collapse collapse--tablet-expanded">
          <div class="collapse__content">

            <!-- Search Checkboxes Filter: Study type -->
            <search-checkboxes-filter :options.prop="[
              { label: 'Taught', name: 'taught', field: 'StudyType', value: 'Taught' },
              { label: 'Research', name: 'research', field: 'StudyType', value: 'Research' },
            ]">
              <div class="filter-heading">
                <legend>Study type</legend>
              </div>
            </search-checkboxes-filter>

            <!-- Search Checkboxes Filter: Study Delivery Method -->
            <search-checkboxes-filter :options.prop="[
              { label: 'Distance learning', name: 'distance-learning', field: 'StudyDeliveryMethod_DistanceLearning', value: 'Yes' },
              { label: 'On-Campus', name: 'on-campus', field: 'StudyDeliveryMethod_OnCampus', value: 'Yes' },
              { label: 'Online learning', name: 'online-learning', field: 'StudyDeliveryMethod_OnlineLearning', value: 'Yes' },
              { label: 'Online with On-Campus elements', name: 'online-with-on-campus-learning', field: 'StudyDeliveryMethod_OnlineLearningWithOnCampus', value: 'Yes' },
            ]">
              <div class="filter-heading">
                <legend>Delivery method</legend>
                <!-- <Popper v-bind="popperConfiguration('delivery-help')" :force-show="true">
                  <template #reference>
                    <span aria-hidden="true">?</span>
                    <span class="sr-only">Delivery method help</span>
                  </template>
                  <p>North Village residences are in Stoke Bishop, East Village residences are in the city centre, West Village residences are mostly in Clifton.</p>
                  <a href="http://www.bristol.ac.uk/accommodation/about/villages/" target="_blank">Find out more.</a>
                </Popper> -->
              </div>
            </search-checkboxes-filter>

            <!-- Search Checkboxes Filter: Faculties -->
            <search-checkboxes-filter :options.prop="[
              { label: 'Arts', name: 'arts', field: 'Faculty', value: 'Arts' },
              { label: 'Engineering', name: 'engineering', field: 'Faculty', value: 'Engineering' },
              { label: 'Health Sciences', name: 'health_sciences', field: 'Faculty', value: 'Health Sciences' },
              { label: 'Life Sciences', name: 'life_sciences', field: 'Faculty', value: 'Life Sciences' },
              { label: 'Science', name: 'science', field: 'Faculty', value: 'Science' },
              { label: 'Social Sciences and Law', name: 'social_sciences_and_law', field: 'Faculty', value: 'Social Sciences and Law' },
            ]">
              <div class="filter-heading">
                <legend>Faculty</legend>
              </div>
            </search-checkboxes-filter>
          </div>
        </div>
      </search-form>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SearchFilters',
    props: {
      filtersCount: Number,
      isFiltering: Boolean,
    },
    methods: {

      /*
       * Returns the configuration for the Popper tooltip component
       *
       * @params {string} buttonId
       * @returns {object}
       */
       popperConfiguration(buttonId = '') {
        return {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [75, 12],
              },
            },
          ],
          referenceIs: 'a',
          referenceProps: {
            id: buttonId,
            class: 'filter-heading__help'
          },
          popperProps: {
            class: 'filter-heading__tooltip'
          },
          popperIs: 'span'
        }
      },
    }
  }
</script>